import RevisableLanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import MediatorManager from "../../../../core/application/MediatorManager";
import SmartphoneNavigateEvent from "../../model/SmartphoneNavigateEvent";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneChatScreenMediator extends AbstractSmartphoneMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {MediatorManager} mediatorManager 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, mediatorManager, languagePack) {
        super(target, dispatcher);

        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this));
        this._backButton = this.createButton(this._target.backButton, this._handleBackButton.bind(this));

        this.addCustomData({
            skinKeyRegistry: SmartphoneSkinKeyRegistry
        });
        this._chatMediator = this._mediatorManager.createMediator(this._target, SmartphoneSkinKeyRegistry.CHAT_SCREEN_SKIN);
    }

    destroy() {
        super.destroy();
        this._chatMediator.destroy();
    }

    _handleBackButton() {
        this._chatMediator.hideKeyDecisionLogo();
        this.closeScreen(this._target);
    }

    _handleCloseButton() {
        // const navEvt = new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST);
        // this.dispatch(navEvt.type, { data: navEvt });

        // this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_MAIN_SCREEN_SKIN);
        this._chatMediator.hideKeyDecisionLogo();
        this.dispatch(SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST)
    }
}